
    export default {
        props: {
            lessons: Array
        }
    }
